export function contractPrintHtml(container: HTMLElement) {
  const source = container.querySelector('[contenteditable]')
  if (!source) {
    throw new Error('合同正文尚未加载')
  }
  const content = source.cloneNode(true) as HTMLElement
  content.removeAttribute('contenteditable')
  content.removeAttribute('role')
  content.removeAttribute('aria-multiline')
  content.removeAttribute('tabindex')
  content.classList.remove('min-h-full')
  const styles = [...document.querySelectorAll('style, link[rel="stylesheet"]')].map((node) => node.outerHTML).join('')
  return `<!doctype html><html lang="zh-CN"><head><meta charset="utf-8">${styles}<style>
    @page { size: A4; margin: 20mm; }
    html, body { background: white !important; color: black !important; }
    body { margin: 0 auto; max-width: 170mm; padding: 10mm 0; }
    [role="textbox"], .contract-editor-content { min-height: 0 !important; padding: 0 !important; }
    table { width: 100%; border-collapse: collapse; } tr { break-inside: avoid; }
    td, th { border: 0.0625rem solid #888; }
    @media print { body { max-width: none; padding: 0; } }
  </style></head><body>${content.outerHTML}</body></html>`
}

export function printContractHtml(html: string) {
  const frame = document.createElement('iframe')
  let disposed = false
  let cleanupTimer: number | undefined

  const cleanup = () => {
    if (disposed) {
      return
    }
    disposed = true
    if (cleanupTimer) {
      window.clearTimeout(cleanupTimer)
    }
    frame.remove()
  }

  frame.title = '合同打印'
  frame.setAttribute('aria-hidden', 'true')
  frame.tabIndex = -1
  frame.className = 'fixed right-0 bottom-0 z-[-1] h-0 w-0 border-0 opacity-0'
  frame.srcdoc = html
  frame.addEventListener(
    'load',
    () => {
      const frameWindow = frame.contentWindow
      if (!frameWindow) {
        cleanup()
        return
      }
      frameWindow.addEventListener('afterprint', cleanup, { once: true })
      frameWindow.focus()
      frameWindow.print()
      cleanupTimer = window.setTimeout(cleanup, 60_000)
    },
    { once: true }
  )
  document.body.append(frame)
}
